import { Row, Col, Divider } from 'antd';

import { Body } from './Body';
import { Header } from './Header';
import { Title } from '@/components/Typography';
import { usePersonalisedReportResultContext } from '../../context';
import { Container } from './styles';

export function Niosh() {
	const { personalisedReportResult } = usePersonalisedReportResultContext();

	const niosh = personalisedReportResult?.tools?.niosh;

	if (!niosh || niosh?.risk === null) {
		return null;
	}

	return (
		<Row justify="center">
			<Col xs={24}>
				<Row gutter={[0, 24]}>
					<Col offset={1} span={23}>
						<Row>
							<Title style={{ margin: 0 }} level={3}>
								Cargo Handling (NIOSH)
							</Title>
						</Row>
					</Col>
					<Col offset={1} span={23}>
						<Row>
							<Container>
								<Header />
								<Divider style={{ margin: 0 }} />
								<Body />
							</Container>
						</Row>
					</Col>
				</Row>
			</Col>
			<Divider type="horizontal" />
		</Row>
	);
}
